module.exports = __webpack_public_path__ + "static/ChannelK_color-color-logo-0f6892fe4738e771d96bb8818d6b2404.png";